<script>
import { Bar } from 'vue-chartjs'
import merge from 'lodash/merge'

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    yLabel: {
      type: String,
      required: false,
      default: '',
    },
    yAxesAdditional: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    startTimestamp: {
      type: String,
      required: false,
      default: '',
    },
    endTimestamp: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  mounted() {
    const yAxes = [
      {
        ticks: {
          beginAtZero: true,
        },
        gridLines: {
          color: 'rgba(166, 176, 207, 0.1)',
        },
        scaleLabel: {
          display: !!this.yLabel,
          labelString: this.yLabel,
        },
      },
    ]

    if (Object.keys(this.yAxesAdditional).length) {
      yAxes.push(this.yAxesAdditional)
    }

    const defaultOptions = {
      defaultFontColor: '#8791af',
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'rgba(166, 176, 207, 0.1)',
            },
          },
        ],
        yAxes,
      },
      legend: {
        position: 'bottom',
      },
    }

    if (this.startTimestamp || this.endTimestamp) {
      defaultOptions.scales.xAxes[0] = merge(defaultOptions.scales.xAxes[0], {
        offset: true,
        type: 'time',
        time: {
          unit: 'hour',
          tooltipFormat: 'DD MMM YYYY HH:mm:ss',
          displayFormats: {
            hour: 'DD MMM YYYY HH:mm:ss',
          },
        },
        ticks: {
          autoSkip: true,
          autoSkipPadding: 40,
          includeBounds: true,
          min: this.startTimestamp || undefined,
          max: this.endTimestamp || undefined,
        },
      })
    }

    const datasets = this.datasets.map((dataset) => ({
      type: 'line',
      ...dataset,
    }))

    this.renderChart(
      {
        labels: this.labels,
        datasets,
      },
      merge(defaultOptions, this.options)
    )
  },
}
</script>
